import { Grid, IconButton, TextField, Autocomplete, Card } from "@mui/material";
import { MealItem } from "../../../../service/model/nutrition.model";
import { DeleteIcon } from "../../../../shared/icons";
import { useAppSelector } from "../../../../app/hooks";
import { selectUnits } from "../../../units/unit.slice";
import { Unit } from "../../../../service/model/unit.model";
import { MealItemWithDetails } from "./meal-card";
import { getNutritionCount } from "../../../../shared/utils";

interface MealItemRowProps {
    mealItem: MealItemWithDetails;
    mealItems: MealItem[];
    onQuantityChange?: (quantity: number) => void;
    onMealItemChange?: (mealItem: MealItem) => void;
    onUnitChange?: (unitId: Unit) => void;
    onDelete?: () => void;
}

const MealItemRow: React.FC<MealItemRowProps> = ({ mealItem, mealItems, onQuantityChange, onMealItemChange, onDelete }) => {
    const units = useAppSelector(selectUnits);
    const mealEntity = mealItems.find((item) => item.id === mealItem.id);

    return (
        <Card variant="outlined" sx={{ p: 2, mb: 2, width: '100%', borderRadius: 2 }}>
            <Grid container alignItems="center" spacing={1} sx={{ mb: { xs: 4, md: 1 } }}>
                <Grid container size={{ xs: 10, sm: 11 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Autocomplete
                            options={mealItems}
                            size="small"
                            value={mealEntity || null}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    onMealItemChange?.(newValue);
                                }
                            }}
                            getOptionLabel={(option: any) => option?.name ?? ''}
                            isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                            renderInput={(params) => <TextField {...params} label="Food Item" variant="standard" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 8, md: 3 }}>
                        <TextField
                            type="number"
                            size="small"
                            label="Quantity"
                            variant="standard"
                            value={mealItem.quantity}
                            disabled={!mealItem.id} // Disable quantity input until a meal item is selected
                            onChange={(e) => {
                                const newQuantity = Number(e.target.value);
                                if (!isNaN(newQuantity)) {
                                    onQuantityChange?.(newQuantity);
                                }
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, md: 3 }}>
                        {/* <Autocomplete
                    options={units}
                    size="small"
                    value={mealItem.unit || null}
                    disabled={!mealItem.id} // Disable unit selection until a meal item is selected
                    onChange={(event, newValue) => {
                        if (newValue) {
                            onUnitChange?.(newValue);
                        }
                    }}
                    getOptionLabel={(option: any) => option?.name ?? ''}
                    isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                    renderInput={(params) => <TextField {...params} label="Unit" variant="standard" />}
                /> */}
                        <TextField
                            size="small"
                            label="Unit"
                            variant="standard"
                            value={mealEntity?.defaultUnit?.name ?? ''}
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                        <TextField
                            size="small"
                            label="Calories"
                            variant="standard"
                            value={getNutritionCount(mealEntity?.defaultQuantity, mealItem?.quantity, mealEntity?.nutrition?.calories)}
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                        <TextField
                            size="small"
                            label="Protein"
                            variant="standard"
                            value={getNutritionCount(mealEntity?.defaultQuantity, mealItem?.quantity, mealEntity?.nutrition?.protein)}
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                        <TextField
                            size="small"
                            label="Carbs"
                            variant="standard"
                            value={getNutritionCount(mealEntity?.defaultQuantity, mealItem?.quantity, mealEntity?.nutrition?.carbohydrates)}
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                        <TextField
                            size="small"
                            label="Fat"
                            variant="standard"
                            value={getNutritionCount(mealEntity?.defaultQuantity, mealItem?.quantity, mealEntity?.nutrition?.fat)}
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                        <TextField
                            size="small"
                            label="Fiber"
                            variant="standard"
                            value={getNutritionCount(mealEntity?.defaultQuantity, mealItem?.quantity, mealEntity?.nutrition?.fiber)}
                            disabled={true}
                        />
                    </Grid>
                    <Grid size={{ xs: 4, sm: 2 }}>
                        <TextField
                            size="small"
                            label="Sugar"
                            variant="standard"
                            value={getNutritionCount(mealEntity?.defaultQuantity, mealItem?.quantity, mealEntity?.nutrition?.sugar)}
                            disabled={true}
                        />
                    </Grid>
                </Grid>
                <Grid size={{ xs: 2, sm: 1 }}>
                    <IconButton aria-label="delete meal item" title="Delete meal item" onClick={onDelete} color="error">
                        <DeleteIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Card>
    );
};

export default MealItemRow;
